import 'react-datepicker/dist/react-datepicker.css'
import '../styles/FundCatalogApp.scss'

import {FC, useEffect} from 'react'
import i18next from 'i18next'
import {ILayout, ILanguage} from '../types/common'
import {CustomConfigurationKey} from '../types/FundCatalog'
import LayoutALL from './LayoutALL'
import LayoutFIO from './LayoutFIO'
import LayoutUFK from './LayoutUFK'
import LayoutOFE from './LayoutOFE'
import LayoutDFE from './LayoutDFE'
import {GlobalContextProvider} from '../common/ctx/providers/GlobalContextProvider'
import {SessionContextProvider} from '../common/ctx/providers/SessionContextProvider'
import {AllFundCatalogContextProvider} from './ctx/providers/AllFundCatalogContextProvider'
import {FioFundCatalogContextProvider} from './ctx/providers/FioFundCatalogContextProvider'
import {UfkFundCatalogContextProvider} from './ctx/providers/UfkFundCatalogContextProvider'
import {OfeFundCatalogContextProvider} from './ctx/providers/OfeFundCatalogContextProvider'
import {DfeFundCatalogContextProvider} from './ctx/providers/DfeFundCatalogContextProvider'
import SVGSpriteSheet from '../common/SVGSpriteSheet'

const FundCatalogApp: FC<{
    contextconfiguration: Record<string, never>
    customconfiguration: Record<CustomConfigurationKey, never>
    i18n?: Record<string, string>
}> = ({contextconfiguration, customconfiguration, i18n}) => {
    const language: ILanguage = customconfiguration.lang
    const layout: ILayout = customconfiguration.layout

    useEffect(() => {
        i18next.changeLanguage(customconfiguration.lang)
    }, [contextconfiguration, customconfiguration, i18n])

    return (
        <>
            <div className="app-allianz">
                <SVGSpriteSheet />
                <GlobalContextProvider layout={layout}>
                    <SessionContextProvider>
                        {layout === 'all' && (
                            <AllFundCatalogContextProvider>
                                <LayoutALL language={language} />
                            </AllFundCatalogContextProvider>
                        )}

                        {layout === 'fio' && (
                            <FioFundCatalogContextProvider>
                                <LayoutFIO language={language} />
                            </FioFundCatalogContextProvider>
                        )}

                        {layout === 'ufk' && (
                            <UfkFundCatalogContextProvider>
                                <LayoutUFK language={language} />
                            </UfkFundCatalogContextProvider>
                        )}

                        {layout === 'ofe' && (
                            <OfeFundCatalogContextProvider>
                                <LayoutOFE language={language} />
                            </OfeFundCatalogContextProvider>
                        )}

                        {layout === 'dfe' && (
                            <DfeFundCatalogContextProvider>
                                <LayoutDFE language={language} />
                            </DfeFundCatalogContextProvider>
                        )}
                    </SessionContextProvider>
                </GlobalContextProvider>
            </div>
        </>
    )
}

export default FundCatalogApp
